function arrayBufferToBase64(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToArrayBuffer(base64: string) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

export async function generateKeyBase64() {
  const keyBytes = new Uint8Array(32);
  crypto.getRandomValues(keyBytes);
  return arrayBufferToBase64(keyBytes.buffer);
}

export async function encryptSecret(secret: string, keyBase64: string) {
  const key = await crypto.subtle.importKey(
    'raw',
    base64ToArrayBuffer(keyBase64),
    'AES-GCM',
    false,
    ['encrypt']
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(secret);
  const ciphertext = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, encoded);
  return `${arrayBufferToBase64(iv.buffer)}:${arrayBufferToBase64(ciphertext)}`;
}

export async function decryptSecret(encryptedData: string, keyBase64: string) {
  const [ivB64, ciphertextB64] = encryptedData.split(':');
  if (!ivB64 || !ciphertextB64) {
    throw new Error('Invalid encrypted data format');
  }

  const key = await crypto.subtle.importKey(
    'raw',
    base64ToArrayBuffer(keyBase64),
    'AES-GCM',
    false,
    ['decrypt']
  );

  const iv = base64ToArrayBuffer(ivB64);
  const ciphertext = base64ToArrayBuffer(ciphertextB64);
  const plaintextBuffer = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ciphertext);
  return new TextDecoder().decode(plaintextBuffer);
}
